<template>
  <IndexPageSection
    :link-string="'一覧へ'"
    :link-url="'/brands'"
    :need-to-move-link-to-bottom="false"
    :section-name="'brand-list-section'"
    :title="'ブランドから探す'"
    :link-data-gtm-page="dataGtmPage"
    :link-data-gtm-click="dataGtmPage ? 'brand_list' : null"
  >
    <div v-if="isBrandsLoading" class="brand-list__loading">
      <Loading />
    </div>
    <div v-else class="brand-list__horizontal-scroll">
      <HorizontalScroll ref="brand-horizontal" ref-name="brand-list">
        <TopBrandIconsList
          :brands="brands"
          :data-gtm-page="dataGtmPage"
          @mount="onMountBrandHorizontal"
        />
      </HorizontalScroll>
    </div>
  </IndexPageSection>
</template>
<script>
import IndexPageSection from './IndexPageSection.vue'
import axios from 'axios'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll.vue'
import Loading from '../../../atoms/loadings/Loading.vue'
import TopBrandIconsList from '../../../molecules/icons/TopBrandIconsList.vue'
export default {
  components: {
    TopBrandIconsList,
    HorizontalScroll,
    IndexPageSection,
    Loading
  },
  props: {
    dataGtmPage: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      isBrandsLoading: false,
      brands: []
    }
  },
  mounted() {
    this.getBrands()
  },
  methods: {
    async getBrands() {
      this.isBrandsLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/brands?limit=10')
        this.brands = res.data.data
          .map(brand => brand.attributes)
          .map(({ id, name, top_image_url }) => ({
            id,
            name,
            top_image_url
          }))
        this.isBrandsLoading = false
      } catch (error) {
        // TODO: Rails 側でエラーが発生した際にフロント側でどのような処理をするかを検討し、ここに実装する
        this.isBrandsLoading = true
        if (
          !error.response ||
          !error.response.status ||
          !error.response.statusText
        ) {
          console.log(`Error :${error}`)
          return
        }
        const { status, statusText } = error.response
        console.log(`Error! HTTP Status: ${status} ${statusText}`)
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
        console.log(`Error message: ${errorMessage}`)
      }
    },
    onMountBrandHorizontal() {
      this.$refs['brand-horizontal'].initializeValues()
    }
  }
}
</script>
